import React, { Component } from 'react';
import { Input as AntdInput, Icon } from 'antd';
import { text, ListRefer, Select, InputNumber, Input, Table, Button, CheckBox, Refer, TimePicker, DatePicker } from '../basic';
import _ from 'lodash';
export default class PromotionGroup extends Component {
  constructor(props) {
    super(props);
    const { meta, viewModel, cStyle } = props;
    const { childrenField, cCode } = meta;
    const controlModel = viewModel.get(childrenField || cCode);
    let sunMeta = null;
    let sunActions = null;
    let sunModel = null;
    let EditRowModels = [];
    let EditRowModelObj = {};
    let gridModelAction = null;
    if (this.props.meta.containers) {
      _.forEach(this.props.meta.containers, (item, index) => {
        item.containers && item.containers.map(container => {
          if (container.cControlType && container.cControlType.toLocaleLowerCase() == 'table') {
            sunMeta = container;
            sunModel = controlModel.getEditRowModel().get(sunMeta.childrenField);
            gridModelAction = container.containers[0];
          } else if (container.cControlType && container.cControlType.toLocaleLowerCase() == "toolbar") {
            sunActions = container.controls;
          }
        })
      })
    }
    let config = null;
    if (cStyle) {
      try { config = JSON.parse(cStyle); } catch (e) { config = {}; }
    }
    let metacStyle = props.meta.cStyle || "{}";
    try { metacStyle = JSON.parse(metacStyle); } catch (e) { metacStyle = {}; }
    let sunConfig = this.initSunModel(sunModel);
    let sunConfigObj = {}, actions = meta.containers ? meta.containers[0].controls : [];
    if (sunMeta)
      sunConfigObj[sunMeta.childrenField] = controlModel.getColumn(sunMeta.childrenField);
    let totalActions = sunActions ? sunActions.concat(actions) : actions;
    let _actionsObj = {}
    totalActions.forEach((item, index) => {
      if (item) {
        _actionsObj[item.cItemName] = item
      }
    })
    let mergerConfig = cb.utils.extend(true, controlModel._get_data('columns'), sunConfigObj, _actionsObj);
    this.state = Object.assign({
      controlModel,
      sunMeta,
      sunActions,
      actions,
      metaclassname: metacStyle.classname,
      cellState: [],
      actionState: [],
      sunModel,
      gridModelAction,
      sunConfig,
      EditRowModelObj,
      EditRowModels,
      mergerConfig
    }, config);
    this.sunGridModels = {};
    this.focusedIndex = -1;
    this.readOnly = false;
  }
  /*初始化孙表*/
  initSunModel = (sunModel) => {
    if (!sunModel) return null;
    let cControlType = sunModel.get('cControlType');
    let suncolumns = sunModel.get('columns');
    let showCheckBox = sunModel.get('showCheckBox');
    let bIsNull = sunModel.get('bIsNull');
    let showRowNo = sunModel.get('showRowNo');
    let showAggregates = sunModel.get('showAggregates');
    let pagination = sunModel.get('pagination');
    let cShowCaption = sunModel.get('cShowCaption');
    return { cControlType, suncolumns, showCheckBox, bIsNull, showRowNo, showAggregates, pagination, cShowCaption, independent: true };
  }
  insertRow(data) {
    const { readOnly, mergerConfig, controlModel } = this.state;
    let dataSource = this.state.dataSource;
    let { index, row } = data;
    dataSource.splice(index, 0, row);
    dataSource = [].concat(controlModel._get_data('rows'));
    const editRowModel = this.setEditRowModel(mergerConfig, index);
    _.forEach(mergerConfig, (column, key) => {
      let item = null;
      let itemButton = null;
      // let buttonVisible = false;
      let model = editRowModel.get(key);
      var controlType = model._get_data('cControlType');
      controlType = controlType && controlType.trim().toLocaleLowerCase();
      if (controlType === 'select') {
        var multiple = model._get_data('multiple');
        var valueField = model._get_data('valueField');
        let currentVal = row[model.getName()];
        row[model.getName()] = (typeof currentVal === 'object' ? currentVal[valueField] : currentVal);
      }
    });
    editRowModel.loadData(row);
    editRowModel.setReadOnly(readOnly);
    this.editRowModels.push(editRowModel);
    this.setState({ dataSource, autoLoad: false })
  }
  updateRow(data) {
    const { index } = data;
    let editRowModel = this.editRowModels[index];
    let row = this.state.controlModel.getRow(index);
    editRowModel.loadData(row);
    editRowModel.setReadOnly(this.state.readOnly);
  }
  componentDidMount() {
    this.state.controlModel && this.state.controlModel.addListener(this);
    if (!this.state.sunMeta) return;
    // this.props.viewModel.get(this.state.sunMeta.childrenField).setState('needClear', false);
    this.props.viewModel.get(this.state.sunMeta.childrenField).on('afterInsertRow', (args) => {
      this.editRowModels[this.focusedIndex].get(this.state.sunMeta.childrenField).appendRow(args.row);
    })
    this.props.viewModel.get(this.state.sunMeta.childrenField).on('afterDeleteRows', (rows, rowIndexes) => {
      this.editRowModels[this.focusedIndex].get(this.state.sunMeta.childrenField).deleteRows(rowIndexes);
    })
  }
  setListenerState(params) {
    this.setState(params);
  }
  setCellState(data) {
    let { cellState } = this.state;
    cellState[data.rowIndex] = {
      [data.cellName]: {
        [data.propertyName]: data.value
      }
    }
    this.setState({ cellState });
  }
  setReadOnly(value) {
    this.editRowModels && this.editRowModels.map(rowModel => {
      rowModel.setReadOnly(value);
    })
    this.readOnly = value;
    this.setState({ readOnly: value });
  }
  // deleteRows(rowIndexes) {
  //   // this.isDelete = true;
  //   const { dataSource } = this.state;
  //   for (var i = rowIndexes.length - 1; i >= 0; i--) {
  //     const rowIndex = rowIndexes[i];
  //     dataSource.splice(rowIndex, 1);
  //   }
  //   const { columns, sunMeta, controlModel, readOnly } = this.state;
  //   this.editRowModels = [];
  //   let { actions, sunActions } = this.state;
  //   // let totalActions = [...actions, ...sunActions];
  //   let totalActions = actions.concat(sunActions);
  //   let _actionsObj = {}
  //   totalActions.forEach((item, index) => {
  //     if (item) {
  //       _actionsObj[item.cItemName] = item
  //     }
  //   })
  //   dataSource.forEach((item, index) => {
  //     let sunConfigObj = {
  //     }
  //     if (sunMeta)
  //       sunConfigObj[sunMeta.childrenField] = controlModel.getColumn(sunMeta.childrenField);
  //     let mergerConfig = cb.utils.extend(true, columns, sunConfigObj, _actionsObj);
  //     const editRowModel = this.setEditRowModel(mergerConfig, index);
  //     editRowModel.loadData(item);
  //     editRowModel.setReadOnly(readOnly);
  //     this.editRowModels.push(editRowModel);
  //   })
  //   this.state.controlModel.setCache('editRowModels', this.editRowModels);
  //   this.setState({ dataSource });
  // }
  setDataSource(dataSource) {
    // if (this.isDelete) {
    //   delete this.isDelete;
    //   return;
    // }
    let { mergerConfig, controlModel } = this.state;
    this.editRowModels = [];
    dataSource = [].concat(controlModel._get_data('rows'));
    dataSource.forEach((item, index) => {
      const editRowModel = this.setEditRowModel(mergerConfig, index);
      _.forEach(mergerConfig, (column, key) => {
        // let buttonVisible = false;
        let model = editRowModel.get(key);
        var controlType = model._get_data('cControlType');
        controlType = controlType && controlType.trim().toLocaleLowerCase();
        if (controlType === 'select') {
          var multiple = model._get_data('multiple');
          var valueField = model._get_data('valueField');
          let currentVal = item[model.getName()];
          item[model.getName()] = (typeof currentVal === 'object' ? currentVal[valueField] : currentVal);
        }
      });
      editRowModel.loadData(item);
      editRowModel.setReadOnly(this.readOnly);
      this.editRowModels.push(editRowModel);
    })
    this.state.controlModel.setCache('editRowModels', this.editRowModels);
    this.setState({ dataSource, mergerConfig });
  }
  ActionClick = (e, action, index) => {
    this.focusedIndex = index;
    this.state.controlModel.setFocusedRowIndex(index);
    let viewModel = this.state.controlModel.getParent();
    let params = { index: index, cItemName: action.cItemName }
    viewModel.get(action.cItemName).fireEvent('click', params);
  }
  renderRow = (row, index) => {
    const { columns, sunMeta, sunConfig, sunActions, mergerConfig } = this.state;
    let items = [];
    let actionsArray = [];
    let sunConfigObj = {};
    if (sunMeta)
      sunConfigObj[sunMeta.childrenField] = sunConfig;
    // let mergerConfig = cb.utils.extend(true, columns, sunConfigObj);
    // var viewModel = this.props.viewModel;
    _.forEach(mergerConfig, (column, key) => {
      if ((cb.utils.isEmpty(column.bShowIt) && cb.utils.isEmpty(column.bHidden)) || (column.bShowIt && !column.bHidden)) {
        let item = null;
        let itemButton = null;
        // let buttonVisible = false;
        let controlType = column.cControlType;
        let config = {};
        if (column.cStyle) {
          try {
            config = JSON.parse(column.cStyle);
          } catch (e) { }
        }
        let model = this.editRowModels[index].get(key);
        switch (controlType && controlType.trim().toLocaleLowerCase()) {
          case 'inputnumber':
            item = (
              <div className={config.classname ? config.classname + " promotionInputNumber" : "promotionInputNumber"}>
                <InputNumber model={model} {...column} />
              </div>
            )
            break;
          case 'timepicker':
            item = <TimePicker className='edit-input-number' model={model} {...column} />
            break;
          case 'datepicker':
            components = <DatePicker model={model} className={'edit-input-number'} cFormatData={col.cFormatData} />
            break;
          case 'table':
            item = <Table model={model} width={this.props.width} action={this.state.gridModelAction} />
            break;
          case 'select':
            item = <div className='promotionSlect'>
              <Select model={model} cShowCaption={column.cShowCaption} className='promotionSlect-content' />
            </div>
            break;
          case 'checkbox':
            item = <div className='promotionCheckbox'>
              <CheckBox model={model} {...column} />
            </div>
            break;
          case 'refer':
            item = <div className='promotionRefer'><Refer model={model} {...column} /></div>
            break;
          case 'input':
            item = <div className="promotionInput"><Input cShowCaption={column.cShowCaption} model={model} className='frc-input' /></div>
            break;
          case 'button':
            // buttonVisible = viewModel.get(column.cItemName) ? viewModel.get(column.cItemName).getVisible() : false;
            itemButton = <Button value={column.cCaption} onClick={(e) => this.ActionClick(e, column, index)} {...column} model={model} className="table-list-btn" />
            break;
        }
        // if (buttonVisible)
        actionsArray.push(itemButton);
        items.push(item)
      }
    });

    return (
      <div onMouseEnter={() => this.onMouseEnter(index)} className="promotion-group-list">
        <div className="operationButton">
          {actionsArray}
        </div>
        {items}
      </div>
    )
  }
  componentWillUpdate(nextProps, nextState) {
    return !_.eq(this.state, nextState)
  }
  onMouseEnter = (index) => {
    this.focusedIndex = index;
    // if (index != this.state.focusedIndex) {
    //   // this.sunGridModels['_' + this.state.focusedIndex].dop
    //   this.state.controlModel.setFocusedRowIndex(index);
    //   this.setState({ focusedIndex: index });
    // }
  }
  renderRows(dataSource) {
    const { iCols } = this.props.meta;
    const controlWidth = 100 / (iCols || 2);
    const className = `width-percent-${controlWidth.toFixed(0)}`;
    return dataSource.map((row, index) => {
      return (
        <div className={className} key={'row' + index}>
          {this.renderRow(row, index)
          }
        </div>
      );
    });
  }
  otherValueChange = function (rowIndex, cellName, data) {
    this.setCellValue(rowIndex, cellName, data, true);
  };

  referValueChange = (rowIndex, cellName, args, bill2ReferKeyFieldMap, checkValid, returnText, referModel) => {
    var data = args.value;
    let _controlModel = this.state.controlModel;
    if (cb.utils.isArray(data)) {
      if (returnText) {
        _controlModel.setCellValue(rowIndex, cellName, args.obj.text, true);
      } else {
        if (!data.length)
          data = [{}];
        var rowDatas = [];
        var referRows = [];
        data.forEach(function (item, index) {
          var rowData = {};
          rowData[cellName] = this.getCellText.call(_controlModel, item, cellName);
          for (var billKey in bill2ReferKeyFieldMap) {
            var billValue = item[bill2ReferKeyFieldMap[billKey]];
            if (billValue == null)
              billValue = null;
            rowData[billKey] = billValue;
          }
          if (index > 0 && !_controlModel.execute('beforeInsertRowFromRefer', { index: rowIndex + index, row: rowData, columnName: cellName })) return;
          rowDatas.push(rowData);
          referRows.push(item);
        }, this);
        _controlModel.promiseExecute('beforeInsertRowsFromRefer', { index: rowIndex, rows: rowDatas, columnName: cellName }, function () {
          var cellEventArgs = { rowIndex: rowIndex, cellName: cellName, value: referRows[0] };
          if (!_controlModel.execute('beforeCellValueChange', cellEventArgs)) return;
          _controlModel.updateRow(rowIndex, rowDatas[0]);
          _controlModel.execute('afterCellValueChange', cellEventArgs);
          if (rowDatas.length > 1) {
            var remainedRows = rowDatas.splice(1);
            _controlModel.insertRows(rowIndex + 1, remainedRows);
            for (var i = 0, len = remainedRows.length; i < len; i++)
              _controlModel.execute('afterCellValueChange', {
                rowIndex: rowIndex + 1 + i,
                cellName: cellName,
                value: referRows[i + 1]
              });
          }
        });
      }
    } else {
      if (cb.utils.isEmpty(data))
        data = {};
      var cellEventArgs = { rowIndex: rowIndex, cellName: cellName, value: data };
      if (!_controlModel.execute('beforeCellValueChange', cellEventArgs)) return;
      var rowData = {};
      rowData[cellName] = this.getCellText.call(_controlModel, data, cellName);
      if (checkValid !== false || typeof data === 'object') {
        for (var billKey in bill2ReferKeyFieldMap) {
          var billValue = data[bill2ReferKeyFieldMap[billKey]];
          if (billValue == null)
            billValue = null;
          rowData[billKey] = billValue;
        }
      }
      _controlModel.updateRow(rowIndex, rowData);
      _controlModel.execute('afterCellValueChange', cellEventArgs);
    }
  };


  getCellText = function (cell, columnName) {
    if (cell == null)
      return cell;
    var columnModel = this.getEditRowModel().get(columnName);
    if (!(columnModel instanceof cb.models.BaseModel))
      return cell;
    var controlType = columnModel._get_data('cControlType');
    controlType = controlType && controlType.trim().toLocaleLowerCase();
    var textField = columnModel._get_data('textField');
    if (controlType === 'refer' || controlType === 'treerefer' || controlType === 'listrefer')
      return typeof cell === 'object' ? (cell[textField] != null ? cell[textField] : null) : cell;
    if (controlType === 'select' || controlType === 'radio' || controlType === "checkboxenum") {
      if (cell == null)
        return cell;
      var multiple = columnModel._get_data('multiple');
      var keyMap = columnModel._get_data('keyMap');
      if (multiple) {
        var items = [];
        if (typeof cell !== 'object') {
          cell.split(',').forEach(function (item) {
            if (!keyMap[item]) return;
            items.push(keyMap[item][textField]);
          });
          cell = items.join('/');
        } else if (cb.utils.isArray(cell)) {
          cell.forEach(function (item) {
            items.push(item[textField]);
          });
          cell = items.join('/');
        }
      } else if (typeof cell !== 'object') {
        var obj = keyMap[cell];
        if (!obj)
          obj = keyMap[cb.utils.getBooleanValue(cell)];
        cell = obj;
      }
      return cell;
      return cell && cell[textField];
    }
    if (controlType === 'tag' || controlType === 'attachment' || controlType === 'checkboxgroup') {
      var items = [];
      cell.forEach(function (item) {
        items.push(item[textField]);
      });
      return items;
    }
    if (controlType === 'cascader' && columnModel._get_data('dataSourceReady'))
      return cell ? columnModel.getNodesByKeys(cell)[0][columnModel._get_data('mergeField') || 'mergername'] : cell;
    return cell;
  }

  getEditFieldModel = (column, attr, index) => {
    let controlType = column.cControlType && column.cControlType.trim().toLocaleLowerCase(), model;
    let _self = this;
    if (controlType == 'table') {
      model = new cb.models.GridModel(cb.utils.extend(true, { needCollect: false }, column));
      model.on('afterInsertRow', () => this.tableValueChange(model, index));
      model.on('afterInsertRows', () => this.tableValueChange(model, index))
      model.on('afterDeleteRows', (rows) => this.tableValueChange(model, index));
      model.on('afterCellValueChange', () => this.tableValueChange(model, index));
      // model.on('afterColumnValueChange',()=>this.tableValueChange(model));
      // var viewModel = this.getParent();
      // while (viewModel.getParent())
      //     viewModel = viewModel.getParent();
      // if (viewModel._get_data(attr))
      //     console.error('孙表暂存出错');
      // viewModel._set_data(attr, model, true);
    } else if (controlType === 'refer') {
      model = new cb.models.ReferModel(cb.utils.extend(true, {}, { multiple: true }, column));
      model.on('afterValueChange', function (data) {
        var context = this.getParent().getParent();
        // var index = context._get_data('focusedRowIndex');
        if (index === -1) return;
        _self.referValueChange.call(context, index, this.getName(), data, this._get_data('bill2ReferKeyFieldMap'), this._get_data('checkValid'), this._get_data('returnText'), this);
        // this.execute('blur');
        // this.execute('afterValueChange', data);
        // return false;
      });
      model.on('beforeBrowse', function () {
        var context = this.getParent().getParent();
        // var index = context._get_data('focusedRowIndex');
        return context.execute('beforeBrowse', { rowIndex: index, cellName: this.getName(), context: this });
      });
    } else if (controlType === 'select' || controlType === 'radio' || controlType === 'checkboxenum') {
      model = new cb.models.ListModel(cb.utils.extend(true, {}, column));
      model.on('afterValueChange', (data) => {
        this.state.controlModel.setCellValue(index, attr, data.value, true);
      });
    } else {
      model = new cb.models.SimpleModel(cb.utils.extend(true, {}, { invalidReset: false }, column));
      model.on('afterValueChange', (data) => {
        this.state.controlModel.setCellValue(index, attr, data.value, true);
      });
      // model.on('blur', () => {
      //   var context = this.state.controlModel;
      //   var rowIndex = this.state.focusedIndex;
      //   var cellName = this.state.sunMeta.childrenField;
      //   if (index === -1) return;
      //   context.doPropertyChange('setCellBlur', { rowIndex: rowIndex, cellName: cellName });
      // });
    }
    return model;
  }
  setEditRowModel = (columns, index) => {
    var fields = {};
    let model;
    for (var attr in columns) {
      model = this.getEditFieldModel(columns[attr], attr, index);
      fields[attr] = model;
    }
    model = new cb.models.ContainerModel();
    model.setParent(this.state.controlModel);
    model.setData(fields);
    return model
  }
  tableValueChange = (model, index) => {
    var context = this.state.controlModel;
    var rowIndex = index;
    var cellName = this.state.sunMeta.childrenField;
    var row = rowIndex >= 0 ? context._get_data('rows')[rowIndex] : null;
    if (!row || !cellName) return;
    row[cellName] = model.getData();
    this.updateRowState(context, rowIndex, cb.models.DataStates.Update);
    if (this.focusedIndex == context.getFocusedRowIndex()) {
      var rowData = context.getRow(this.focusedIndex);
      context.getEditRowModel().setData(rowData);
    }
  };
  updateRowState = function (model, rowIndex, dataState) {
    var rowsDataState = model._get_data('rowsDataState');
    var ds = model._get_data('dataSource'),
      rowsInPage = model._get_data('rows');
    var indexInDS = ds.indexOf(rowsInPage[rowIndex]);
    var currentDataState = rowsDataState[indexInDS];
    if (currentDataState !== cb.models.DataStates.Insert && currentDataState !== cb.models.DataStates.Delete)
      rowsDataState[indexInDS] = dataState;
  };
  render() {
    let { dataSource, classname, metaclassname } = this.state;
    if (!dataSource || !dataSource.length) dataSource = [];
    return (
      <div key={dataSource.length} className={`member-list ${classname || ''} ${metaclassname}`}>
        {this.renderRows(dataSource)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/PromotionGroup.jsx